import { Directive, NgZone, inject, OnInit } from '@angular/core';
import { DatePickerComponent, DateTimePickerComponent, TimePickerComponent } from '@progress/kendo-angular-dateinputs';

@Directive({
  selector: '[scrollPicker]',
  standalone: true,
})
export class ScrollPickerDirective implements OnInit {
  zone = inject(NgZone);
  datePicker = inject(DatePickerComponent, { optional: true });
  timePicker = inject(TimePickerComponent, { optional: true });
  dateTimePicker = inject(DateTimePickerComponent, { optional: true });

  ngOnInit() {
    const target = this.dateTimePicker ?? this.timePicker ?? this.datePicker;
    target.open.subscribe(() => {
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          {
            (target as any).popupRef.popupElement.classList.add('scroll-picker');
          }
        });
      });
    });
  }
}
